function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
import { StyleSheet, css } from '@coursera/aphrodite/no-important';
import classNames from 'classnames';
import transition from "./transition";
import { coursera, strawberry, peach, pear, kiwi, sea, blueberry, grape, productCardSpecialization } from "./gradients";

// Easier to write with ...css than always use className as it's not strictly className
function cssWithClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  /**
   * This function has been updated in https://phabricator.dkandu.me/D103061
   * It used to have a condition checking whether the first argument is a string, and
   * pass the rest to aphrodite. Aphrodite does not handle strings (class names)!
   */
  var styles = args.reduce(function (all, item) {
    return typeof item !== 'string' ? [].concat(_toConsumableArray(all), [item]) : all;
  }, []);
  var aphroditeClassName = css.apply(void 0, _toConsumableArray(styles));
  var otherClassNames = args.reduce(function (all, item) {
    return typeof item === 'string' ? [].concat(_toConsumableArray(all), [item]) : all;
  }, []);
  return {
    className: classNames.apply(void 0, [aphroditeClassName].concat(_toConsumableArray(otherClassNames))) || undefined
  };
}
export { StyleSheet };
export { cssWithClass as css };
export { cssWithClass };
export { transition };
var containerMaxWidth = {
  xs: 288,
  sm: 576,
  md: 792,
  lg: 1008,
  // 936, 960 doesn't fit for 12 points
  xl: 1152,
  xxl: 1440
};
var color = {
  primary: 'var(--cds-color-blue-600, #2A73CC)',
  darkPrimary: 'var(--cds-color-blue-700, #0156B8)',
  lightPrimary: 'var(--cds-color-blue-300, #82A8E1)',
  accent: 'var(--cds-color-blue-300, #3BAFDA)',
  aliceBlue: 'var(--cds-color-grey-25, #F5F7FA)',
  navyBlue: 'var(--cds-color-blue-950, #263674)',
  skyBlue: 'var(--cds-color-blue-400, #1E9EF5)',
  lightCyan: 'var(--cds-color-green-25, #E7FDFF)',
  deepAzure: 'var(--cds-color-blue-900, #083E7D)',
  primaryText: 'var(--cds-color-grey-975, #1F1F1F)',
  primaryTextThemeDark: 'var(--cds-color-white-0, #ffffff)',
  secondaryText: 'var(--cds-color-grey-600, #666666)',
  secondaryTextThemeDark: 'var(--cds-color-grey-25, #F5F7FA)',
  lightGrayText: 'var(--cds-color-grey-400, #969696)',
  divider: 'var(--cds-color-grey-25, #E1E1E1)',
  dividerLight: 'var(--cds-color-grey-25, #F0F0F0)',
  dividerThemeDark: 'var(--cds-color-grey-200, #BDBDBD)',
  border: 'var(--cds-color-grey-200, #BDBDBD)',
  borderThemeDark: 'var(--cds-color-grey-25, #E1E1E1)',
  borderFocused: 'var(--cds-color-blue-600, #2A73CC)',
  disabled: 'var(--cds-color-grey-200, #BDBDBD)',
  disabledThemeDark: 'var(--cds-color-grey-600, #646668)',
  disabledText: 'var(--cds-color-grey-25, #FDFEFF)',
  disabledTextThemeDark: 'var(--cds-color-grey-25, #E3E4E5)',
  bgGray: 'var(--cds-color-grey-25, #F5F5F5)',
  bgGrayThemeMid: 'var(--cds-color-grey-400, #888888)',
  bgGrayThemeDark: 'var(--cds-color-grey-500, #757575)',
  bgDarkGray: 'var(--cds-color-grey-600, #666666)',
  bgPaper: 'var(--cds-color-grey-25, #F5F5F5)',
  icon: 'var(--cds-color-grey-900, #363B42)',
  iconThemeDark: 'var(--cds-color-grey-25, #EBECED)',
  shadow: 'var(--cds-color-grey-25, #E6E9ED)',
  lightGray: 'var(--cds-color-grey-25, #FDFEFF)',
  gray: 'var(--cds-color-grey-25, #EBECED)',
  darkGray: 'var(--cds-color-grey-200, #CCD1D9)',
  white: 'var(--cds-color-white-0, #ffffff)',
  black: 'var(--cds-color-grey-975, #1F1F1F)',
  warning: 'var(--cds-color-yellow-300, #F7BB56)',
  danger: 'var(--cds-color-yellow-500, #E85628)',
  // TODO rename as 'alert'
  error: 'var(--cds-color-red-800, #D30001)',
  success: 'var(--cds-color-green-600, #1F8354)',
  info: 'var(--cds-color-blue-700, #20589D)',
  bgWarning: 'var(--cds-color-yellow-50, #FCEBCE)',
  bgDanger: 'var(--cds-color-red-50, #FBE5DF)',
  // TODO rename as 'alert'
  bgError: 'var(--cds-color-red-50, #FFE0E5)',
  bgSuccess: 'var(--cds-color-green-25, #DFF3EA)',
  bgInfo: 'var(--cds-color-blue-25, #EAF4FE)',
  admin: 'var(--cds-color-blue-800, #0D47A1)',
  superUser: 'var(--cds-color-pink-700, #9C27B0)'

  // b2c: 'var(--cds-color-green-400, #37BC9B)',
  // b2b: 'var(--cds-color-blue-400, #5D9CEC)',
  // degree: 'var(--cds-color-blue-300, #3BAFDA)',
};
export { color };
var spacing = {
  minWidth: 360,
  // Smallest screen we want to support
  xxs: '0.1875rem',
  xs: '0.375rem',
  sm: '0.75rem',
  md: '1.125rem',
  lg: '1.5rem',
  xl: '3rem',
  xxl: '4.5rem'
};
export { spacing };
var iconSize = {
  xxs: 14,
  xs: 18,
  sm: 24,
  md: 32,
  lg: 48,
  xl: 64,
  xxl: 128
};
export { iconSize };
var breakPoint = {
  xs: containerMaxWidth.xs + 32,
  sm: containerMaxWidth.sm + 32,
  md: containerMaxWidth.md + 32,
  lg: containerMaxWidth.lg + 32,
  xl: containerMaxWidth.xl + 32,
  xxl: containerMaxWidth.xxl + 32
};
export { breakPoint };
export { containerMaxWidth };
var gradient = {
  primary: coursera,
  secondary: strawberry,
  coursera: coursera,
  strawberry: strawberry,
  peach: peach,
  pear: pear,
  kiwi: kiwi,
  sea: sea,
  blueberry: blueberry,
  grape: grape,
  productCardSpecialization: productCardSpecialization
};
export { gradient };
var zIndex = {
  none: 0,
  xs: 1000,
  sm: 2000,
  // FixedContainer
  md: 3000,
  // SmartScrollWrapper
  lg: 4000,
  xl: 10000,
  // Critical, e.g. modal
  xxl: 10001
};
export { zIndex };
var font = {
  xxs: '0.625rem',
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1.25rem',
  lg: '1.5rem',
  xl: '2.125rem',
  xxl: '3rem',
  xxxl: '4.5rem'
};
export { font };
var fontWeight = {
  light: '300',
  normal: '400',
  semibold: '600',
  bold: '700'
};
export { fontWeight };
var fontFamily = {
  body: 'OpenSans, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headline: "'OpenSans-Light', OpenSans, Arial, sans-serif",
  display: "'Merriweather-Light', Georgia, serif",
  bold: "'OpenSans-Bold', OpenSans, Arial, sans-serif",
  displayBold: "'Merriweather', Georgia, serif"
};
export { fontFamily };
var shimmerAnimationDuration = 1.3;
var shimmerKeyframes = {
  '0%': {
    backgroundPosition: '-468px 0'
  },
  '100%': {
    backgroundPosition: '468px 0'
  }
};
var shimmerStyles = StyleSheet.create({
  shimmer: {
    animationName: shimmerKeyframes,
    animationDuration: "".concat(shimmerAnimationDuration, "s"),
    animationIterationCount: 'infinite',
    animationDillMode: 'forwards',
    animationTimingFunction: 'linear',
    background: 'linear-gradient(to right, var(--cds-color-grey-25, #eeeeee) 8%, var(--cds-color-grey-25, #dddddd) 18%, var(--cds-color-grey-25, #eeeeee) 33%)',
    backgroundSize: '1000px 104px',
    position: 'relative',
    overflow: 'hidden'
  }
});
var placeholder = {
  animationDuration: shimmerAnimationDuration,
  keyframes: shimmerKeyframes,
  styles: shimmerStyles
};
export { placeholder };
export default {
  StyleSheet: StyleSheet,
  css: cssWithClass,
  cssWithClass: cssWithClass,
  transition: transition,
  spacing: spacing,
  color: color,
  iconSize: iconSize,
  breakPoint: breakPoint,
  containerMaxWidth: containerMaxWidth,
  gradient: gradient,
  zIndex: zIndex,
  font: font,
  fontWeight: fontWeight,
  fontFamily: fontFamily,
  placeholder: placeholder
};